import React from "react";
import { Box, Typography } from "@mui/material";

const GlobalSubHeading = ({
  subTitle,
  ParentContainer = {},
  containerSx = {},
  textSx = {},
}) => {
  return (
    <Box sx={{ ...styles.RootContainer, ...ParentContainer }}>
      <Typography
        variant="subtitle1"
        color="text.secondary"
        // sx={[styles.SubHeadingTxt]}
        sx={{ ...styles.SubHeadingTxt, ...textSx }}
      >
        {subTitle}
      </Typography>
    </Box>
  );
};

export default GlobalSubHeading;

const styles = {
  RootContainer: { padding: "0px px" },

  SubHeadingTxt: {
    color: "grey",
    fontWeight: "400",
    alignItems: "center",
    textAlign: "center",
    // textAlign: "justify",
    fontFamily: '"Poppins", serif',
    width: { xs: "100%", sm: "100%", md: "91%" },
    fontSize: { xs: "0.9rem", sm: "0.9rem", md: "0.96rem" },
  },
};
